import { Format, Selector, SortFunction, SortOrder } from './types';

export function getProperty<T>(
    row: T,
    selector: Selector<T> | undefined | null,
    format: Format<T> | undefined | null,
    rowIndex: number,
): React.ReactNode {
    if (!selector) {
        return null;
    }

    // format will override how the selector is displayed but the original dataset is used for sorting
    if (format && typeof format === 'function') {
        return format(row, rowIndex);
    }

    return selector(row, rowIndex);
}

export function prop<T, K extends keyof T>(obj: T, key: K): T[K] {
    return obj[key];
}

export function isEmpty(field: string | number | undefined = ''): boolean {
    if (typeof field === 'number') {
        return false;
    }

    return !field || field.length === 0;
}

export const noop = (): null => null;

export function sort<T>(
	rows: T[],
	selector: Selector<T> | null | undefined,
	direction: SortOrder,
	sortFn?: SortFunction<T> | null,
): T[] {
	if (!selector) {
		return rows;
	}

	if (sortFn && typeof sortFn === 'function') {
		// we must create a new rows reference
		return sortFn(rows.slice(0), selector, direction);
	}

	return rows.slice(0).sort((a: T, b: T) => {
		const aValue = selector(a);
		const bValue = selector(b);

		if (direction === 'asc') {
			if (aValue < bValue) {
				return -1;
			}

			if (aValue > bValue) {
				return 1;
			}
		}

		if (direction === 'desc') {
			if (aValue > bValue) {
				return -1;
			}

			if (aValue < bValue) {
				return 1;
			}
		}

		return 0;
	});
}